module.exports = __webpack_public_path__ + "static/Tax_Banner_63_Mobile.53cc9906.png";